var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "welfare-bind" },
    [
      _c("div", { staticClass: "figure" }),
      _c(
        "div",
        { staticClass: "bind-title" },
        [
          _vm.isShow
            ? _c("AutoFontSize", [_vm._v(_vm._s(_vm.$t("welfare_bind_title")))])
            : _vm._e(),
        ],
        1
      ),
      _c("div", { staticClass: "content" }, [
        _c(
          "div",
          { staticClass: "line line-1" },
          [
            _vm.isShow
              ? _c("AutoFontSize", [
                  _vm._v(_vm._s(_vm.$t("welfare_bind_tips_1"))),
                ])
              : _vm._e(),
          ],
          1
        ),
        _c("div", { staticClass: "line line-2" }, [
          _vm._v(_vm._s(_vm.$t("welfare_bind_tips_2"))),
        ]),
        _c("div", { staticClass: "award" }),
        _c("div", { staticClass: "btn", on: { click: _vm.onBtnBindClick } }, [
          _vm._v(_vm._s(_vm.$t("welfare_bind_btn"))),
        ]),
        _vm.isComplete ? _c("div", { staticClass: "complete" }) : _vm._e(),
        _c("div", { staticClass: "rules" }, [
          _vm._v("* " + _vm._s(_vm.$t("WEB_only_tips"))),
        ]),
      ]),
      _c(
        "i18n",
        {
          staticClass: "tips",
          attrs: { path: "text_privacy_tips", tag: "div" },
        },
        [
          _c(
            "span",
            { attrs: { slot: 0 }, on: { click: _vm.seePrivacy }, slot: 0 },
            [_vm._v(_vm._s(_vm.$t("text_privacy")))]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }